/* KO – "Dodato u korpu" u panelu korpe, samo kada se panel otvori posle dodavanja proizvoda */
(function(){
  var addedAt=0;
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.cartUpdate,function(ev){ if(ev&&(ev.source==='product-form'||ev.source==='elia-quick')) addedAt=Date.now(); });
  }
  document.addEventListener('submit',function(e){ var f=e.target; var id=f&&f.getAttribute&&f.getAttribute('id')||''; if(id.indexOf('product-form-')===0||f.closest&&f.closest('[data-elia-quick]')) addedAt=Date.now(); },true);
  function sync(){
    var d=document.querySelector('cart-drawer'); if(!d) return;
    var show=d.classList.contains('active')&&Date.now()-addedAt<6000;
    d.querySelectorAll('.elia-ko-added').forEach(function(el){ el.hidden=!show; });
  }
  function init(){
    var d=document.querySelector('cart-drawer'); if(!d) return;
    new MutationObserver(sync).observe(d,{attributes:true,attributeFilter:['class'],childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
